import { useNavigate } from 'react-router-dom';

import creativesSvg from 'assets/icons/creatives.svg';

import Auth from 'modules/Auth';
import { PermissionsEnum } from 'consts/permissions';
import Button, { Color, Size, TextSize } from 'lib/Button';
import SingleContent from 'components/common/layout/SingleContent';

import ContentManagementHeader from '../ContentManagementHeader';
import Main from './Content';

const Creatives: React.FC = () => {
  const navigate = useNavigate();

  const actionButton = Auth.hasPermission(PermissionsEnum.CONTENT_UPLOAD) ? (
    <Button
      label="Upload creative"
      onClick={() => navigate('/content-management/uploadCreative')}
      color={Color.PRIMARY}
      size={Size.MEDIUM}
      svg={creativesSvg}
      textSize={TextSize.MEDIUM}
      classNames="flex space-x-2"
      svgClassnames="!w-3.5 !h-3.5"
    />
  ) : null;

  return (
    <>
      <ContentManagementHeader actionButton={actionButton} />
      <SingleContent content={<Main />} />
    </>
  );
};

export default Creatives;
